import * as endpoints from '@App/constants/endpoints';
import interceptor from '../interceptor';
import { get } from '../util';

const REPORTS = 'reports';
const FORMS = 'forms';
const EXCEL = 'excel';

export const generateFormReport = async ({ 
  header, 
  formModelId, 
  patientIds, 
  includePatientData = true, 
  includeProfessionalData = true,
  simpleReport = false 
}) => {
  let pathUrl = `${endpoints.API_FORMS}/${REPORTS}/${FORMS}/${EXCEL}?formModelId=${formModelId}`;
  
  if (patientIds && patientIds.length > 0) {
    pathUrl += `&patientIds=${patientIds.join(',')}`;
  }
  
  pathUrl += `&includePatientData=${includePatientData}`;
  pathUrl += `&includeProfessionalData=${includeProfessionalData}`;
  pathUrl += `&simpleReport=${simpleReport}`;

  const axios = interceptor(header);
  
  axios.defaults.responseType = 'blob';
  
  return await get(axios, pathUrl);
}; 